import React from 'react';
import { Link } from 'react-router-dom';

const AssignmentList = ({ assignments, userRole }) => {
    return (
        <ul className="space-y-4">
            {assignments.map(assignment => (
                <li key={assignment.id} className="p-4 bg-white shadow-md rounded-lg flex justify-between items-center">
                    <div>
                        <h4 className="text-lg font-semibold text-primary">{assignment.name}</h4>
                        <p className="text-sm text-gray-500">Type: {assignment.type}</p>
                    </div>
                    {userRole === 'Student' && assignment.type === 'On-App' && (
                        <Link to={`/assignments/${assignment.id}/take`}>
                            <button className="px-4 py-2 text-white bg-green-600 rounded-lg hover:bg-green-700">
                                Take Exam
                            </button>
                        </Link>
                    )}
                </li>
            ))}
        </ul>
    );
};

export default AssignmentList;
